import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Benifits_Component from "../../../Common_Component/Benifits_Component/Benifits_Component";

const Print_Media_Benefits = () => {
  const benifitsData = [
    {
      title: "Unique Identity",
      descn:
        "Stand out from competitors with a custom-designed logo tailored to your brand.",
    },
    {
      title: "Professional Appeal",
      descn: "A polished logo builds trust and credibility with your audience.",
    },
    {
      title: "Versatility",
      descn:
        "Designed to look great across all platforms-social media, websites, packaging, and more.",
    },
    {
      title: "Timeless Design",
      descn: "Create a logo that remains relevant as your business grows.",
    },
    {
      title: "Memorability",
      descn:
        "Make a strong first impression with a logo that sticks in customer’s minds.",
    },
  ];

  return (
    <div className="Benifits">
      <div className="container">
        <div className="title_div">
          <p className="title">Benefits</p>
        </div>

        <div className="card_holder_main_div">
          <Swiper
            className="mySwiper"
            spaceBetween={10}
            slidesPerView={6}
            modules={[Pagination]}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            breakpoints={{
              // when window width is >= 320px
              0: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              425: {
                slidesPerView: 1.3,
                spaceBetween: 15,
              },
              // when window width is >= 768px
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              // when window width is >= 1024px
              1200: {
                slidesPerView: 3,
                spaceBetween: 25,
              },
              1400: {
                slidesPerView: 3,
                spaceBetween: 25,
              },
            }}
          >
            {benifitsData?.length > 0 &&
              benifitsData?.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <Benifits_Component
                      className={index == 0 ? "first-component" : ""}
                      title={item?.title}
                      description={item?.descn}
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Print_Media_Benefits;
